import React from 'react';
import { IconContext } from 'react-icons';
import { BsEnvelope, BsLightning } from 'react-icons/bs';
import { Heading, Paragraph, FlexBox } from 'src/lib/StyledComponents';
import theme from 'src/lib/theme';

import { ON_PREM_CRM, SPS_CRM, DONORPERFECT_CRM } from 'src/utils/authOrg.constants';
import styles from '../index.css';

const IconWrapper = props => (
	<IconContext.Provider
		value={{
			size: '30px',
			style: {
				color: theme.colors.lightBlue,
				marginRight: '15px',
			},
		}}
	>
		{props.children}
	</IconContext.Provider>
);

const Intermission = props => {
	const supportedCRMs = [ON_PREM_CRM, SPS_CRM, DONORPERFECT_CRM];
	return (
		<FlexBox className={styles.SetupCardLayout}>
			<Heading {...theme.heading.setUpTitle}>Welcome to Wisely</Heading>
			{supportedCRMs.includes(props.authOrganizations[0].crm_type) ? (
				<React.Fragment>
					<FlexBox alignItems="center">
						<IconWrapper>
							<BsLightning />
						</IconWrapper>
						<p>We're setting up your system as quickly as possible.</p>
					</FlexBox>
					<FlexBox alignItems="center">
						<IconWrapper>
							<BsEnvelope />
						</IconWrapper>
						<Paragraph>
							In the meantime, feel free to click away from this page. <br />
							We'll be in touch once everything is ready.
						</Paragraph>
					</FlexBox>
				</React.Fragment>
			) : (
				<FlexBox alignItems="center">
					<IconWrapper>
						<BsEnvelope />
					</IconWrapper>
					<Paragraph mt="21px">We'll be in touch soon!</Paragraph>
				</FlexBox>
			)}
		</FlexBox>
	);
};

export default Intermission;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Setup/Intermission/index.js